import { Component } from '.';
import { BoxDimensions, Report } from '../../interfaces';

/**
 * Collider component.
 */
export class Collider extends Component {
	public state: {
		mesh?: string | BoxDimensions;
		observe: boolean;
		ignoreConnected: boolean;
	} = { observe: true, ignoreConnected: true };
	public onCollision = new Set<(colliders: Set<Report>) => void>();
	public onCollisionEnd = new Set<() => void>();
}
